import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAuthentication, sendOTP } from "../../../redux/actions/auth";
import "./style.css";
import { isMobileDevice } from "../../../helper";

const LoginForm = ({ onComplete, toggleForm }) => {

  const isMobile = isMobileDevice();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ mobile: "" });

  const authentication = useSelector(state => state.auth.authentication);

  const { mobile } = formData;
  const [error, setError] = useState(false);

  const onChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFocus = () => {
    dispatch(resetAuthentication());
    setError(false);
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    const regex = /^([+]\d{2})?\d{10}$/;
    if (regex.test(mobile)) {
      localStorage.clear();
      dispatch(sendOTP({ mobile }, onComplete));
    } else {
      setError(true);
    }
  };

  const getTitle = () => {
    if (authentication.hasOwnProperty("code") && authentication.code == 500) {
      let subtitile = "This account does not exists. Enter the correct number or create a new account";
      if (authentication.message == "Number format incorrect!") subtitile = "Number format incorrect. Enter the correct number or create a new account";
      return { title: authentication.message, subtitile }
    } else if (error) {
      return { title: "Number format incorrect!", subtitile: "Number format incorrect. Enter the correct number or create a new account" }
    } else {
      return { title: "Existing users : Login", subtitile: "" }
    }
  }

  return (
    <div className="login-form form-sec">
      <p className="form-heading">{getTitle().title}</p>
      <form className="main-form">
        <p>{getTitle().subtitile}</p>
        <div className={`form-feild ${(error || authentication?.message == "Number format incorrect!") ? 'form-error' : ''}`}>
          <label htmlFor="mobileno" className="form-label">Mobile number (10 digits)</label>
          <input type={isMobile ? 'number' : 'text'} inputMode='decimal' className="form-control" name="mobile" onChange={(e) => onChange(e)} onFocus={handleFocus} id="mobileno" />
        </div>
        <button onClick={(e) => onSubmit(e)} className="btn purple-button">Send OTP</button>
        <div className="form-devider"></div>
        <p className="create-account">New User? <a className="nav-link" onClick={() => toggleForm(true)}>Create account</a></p>
      </form>
    </div>
  );
};

export default LoginForm;
